import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/vexon")({
  staticData: {
    title: "Vexon Voice Detector",
  },
  head: () => ({
    meta: [
      {
        name: "description",
        content:
          "Detect deepfake voices and phishing audio in seconds with Polygraf AI’s Deepfake Audio Detection - advanced acoustic forensics for fraud prevention, deployable in local or on-premises environments.",
      },
    ],
  }),
});
